import React from "react";
import { Link } from "react-router-dom";

export const Header = () => (
  <header className="sticky top-0 z-40 backdrop-blur-xl bg-white/80 border-b border-[#D0E2FF]/60">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
      <Link to="/" data-testid="logo-home-button" className="flex items-center gap-3">
        <img
          src="/nexus-logo.png"
          alt="Nexus Numbers Paystub Generator logo"
          width="40"
          height="40"
          className="h-10 w-10 object-contain rounded"
        />
        <span className="flex flex-col leading-none text-left">
          <span className="font-display font-bold text-xl sm:text-2xl tracking-tight text-[#1E40AF]">
            Nexus Numbers
          </span>
          <span className="text-[11px] font-medium text-[#64748B] tracking-wide">
            Paystubs &amp; Earnings Statements
          </span>
        </span>
      </Link>
      <nav className="hidden md:flex items-center gap-6 text-sm font-medium text-[#475569]">
        <Link to="/self-employed-paystubs" className="hover:text-[#1E40AF] transition-colors">Self-Employed</Link>
        <Link to="/contractor-paystubs" className="hover:text-[#1E40AF] transition-colors">Contractors</Link>
        <Link to="/blog" className="hover:text-[#1E40AF] transition-colors">Blog</Link>
        <Link to="/create" className="rounded-full bg-[#60A5FA] hover:bg-[#2563EB] text-white px-4 py-2 transition-colors">
          Create Paystub
        </Link>
      </nav>
    </div>
  </header>
);
